<div class="container-fluid">
  <div class="row">
    <app-widget-panel [title]="getWidgetTitle()">
      <div class="container d-flex flex-column h-100">
        <div class="row">
          <h3 class="vive-blue text-center">{{ getWidgetTitle() }}</h3>
        </div>

        <div class="row flex-grow-1 overflow-y-auto">
          <div class="col d-flex flex-column">
            <div class="row flex-grow-1">
              <div class="col inner-panel rounded">
                <ul class="vive-blue_list mb-0">
                  @for (
                    alert of alertDataMap | keyvalue: keyValuePairDefaultOrder;
                    track alert
                  ) {
                    <a
                      (click)="navigateToGrid(alert)"
                      class="text-decoration-none cursor-select"
                      ngbTooltip="{{ alert.key }} last 30 days."
                    >
                      @if (isObjectWithCount(alert.value)) {
                        <li class="py-1">
                          {{ isAViveStatus(alert.key) ? 'Recently' : 'Recent' }}
                          <span appStatusStyleChanges>{{ alert.key }}</span>
                          @if (isAViveStatus(alert.key)) {
                            <span> Vendors</span>
                          }
                          <span class="fw-semibold">
                            ({{ alert.value.count }})</span
                          >
                        </li>
                      }
                    </a>
                  }

                  @if (
                    usersLoggedInLast30Days &&
                    userAccountRole === 'CLIENT_ADMIN'
                  ) {
                    <div
                      class="h-auto cursor-select"
                      (click)="
                        onClickNavigateToUsersGrid(
                          usersLoggedInLast30Days.FilterModel,
                          'Logged in last 30 days'
                        )
                      "
                    >
                      <li class="py-1">
                        <span class="fw-semibold"
                          >Users Logged In Last 30 Days</span
                        >
                        <span class="fw-semibold text-center"
                          >({{ usersLoggedInLast30Days.count }})</span
                        >
                      </li>
                    </div>
                  }

                  @if (
                    usersNotLoggedInLast30Days &&
                    userAccountRole === 'CLIENT_ADMIN'
                  ) {
                    <div
                      class="h-auto cursor-select"
                      (click)="
                        onClickNavigateToUsersGrid(
                          usersNotLoggedInLast30Days.FilterModel,
                          'Not logged in last 30 days'
                        )
                      "
                    >
                      <li class="py-1">
                        <span class="fw-semibold"
                          >Users Not Logged In Last 30 Days</span
                        >
                        <span class="fw-semibold text-center"
                          >({{ usersNotLoggedInLast30Days.count }})</span
                        >
                      </li>
                    </div>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-widget-panel>
  </div>
</div>
